import apiClient from "@/clients/apiClient";

/** Respuesta envuelta por el interceptor del backend */
interface RefreshResponseBody {
  data: { access_token: string };
  message: string;
  status: number;
}

export async function refreshSessionAction(): Promise<string> {
  const { data } = await apiClient.post<RefreshResponseBody>("/auth/refresh");
  const accessToken = data?.data?.access_token;
  if (!accessToken) {
    throw new Error("Respuesta de renovación sin access_token");
  }
  return accessToken;
}
